<div class="projects_shadow_red"><img src="{{ project.shadow }}" alt=""></div>
<div class="project" [class.row_reverse]="project.reverse">
    <img [attr.data-aos]="project.reverse ? 'fade-left' : 'fade-right'" src="{{ project.img }}" alt="">
    <div [attr.data-aos]="project.reverse ? 'fade-right' : 'fade-left'" class="project_description" [class.ai_end]="project.reverse">
        <h3>{{ project.name }}</h3>
        <h4>{{ project.skillTypes }} </h4>
        <span>{{ project.description }}</span>
        <div class="project_btn" *ngIf="!project.ownBackEnd">
            <a class="test_btn" href="{{ project.liveLink }}" target="_blank">Live Test</a>
            <a class="git_btn" href="{{ project.gitLinkFrontEnd }}" target="_blank">Github</a>
        </div>
        <div class="project_btn_with_own_backend" *ngIf="project.ownBackEnd">
            <a class="test_btn" href="{{ project.liveLink }}" target="_blank">Live Test</a>
            <a class="git_btn" href="{{ project.gitLinkFrontEnd }}" target="_blank">Github FrontEnd</a>
            <a class="git_btn" href="{{ project.gitLinkBackEnd }}" target="_blank">Github BackEnd</a>
        </div>
    </div>
</div>